var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3336 28.6655H31.3336C30.6263 28.6655 29.9481 28.9464 29.448 29.4465C28.9479 29.9466 28.6669 30.6249 28.6669 31.3322C28.6669 32.0394 28.9479 32.7177 29.448 33.2178C29.9481 33.7179 30.6263 33.9988 31.3336 33.9988H36.6669C37.3742 33.9988 38.0524 34.2798 38.5525 34.7799C39.0526 35.28 39.3336 35.9583 39.3336 36.6655C39.3336 37.3727 39.0526 38.051 38.5525 38.5511C38.0524 39.0512 37.3742 39.3322 36.6669 39.3322H28.6669M34.0003 41.9988V25.9988M23.1336 29.4922C22.939 28.6155 22.9689 27.704 23.2205 26.8419C23.4721 25.9799 23.9373 25.1954 24.5729 24.5611C25.2085 23.9268 25.994 23.4633 26.8565 23.2135C27.7191 22.9637 28.6307 22.9357 29.5069 23.1322C29.9892 22.3779 30.6536 21.7572 31.4389 21.3272C32.2241 20.8972 33.105 20.6719 34.0003 20.6719C34.8955 20.6719 35.7764 20.8972 36.5617 21.3272C37.3469 21.7572 38.0113 22.3779 38.4936 23.1322C39.3711 22.9349 40.2844 22.9627 41.1483 23.2131C42.0122 23.4635 42.7987 23.9283 43.4347 24.5644C44.0707 25.2004 44.5356 25.9869 44.786 26.8508C45.0364 27.7147 45.0642 28.6279 44.8669 29.5055C45.6212 29.9878 46.2419 30.6522 46.6719 31.4374C47.1018 32.2227 47.3272 33.1036 47.3272 33.9988C47.3272 34.8941 47.1018 35.775 46.6719 36.5602C46.2419 37.3455 45.6212 38.0099 44.8669 38.4922C45.0634 39.3684 45.0354 40.28 44.7856 41.1426C44.5358 42.0051 44.0723 42.7906 43.438 43.4262C42.8037 44.0618 42.0191 44.527 41.1571 44.7786C40.2951 45.0302 39.3836 45.0601 38.5069 44.8655C38.0253 45.6227 37.3604 46.246 36.5738 46.6779C35.7872 47.1098 34.9043 47.3362 34.0069 47.3362C33.1096 47.3362 32.2267 47.1098 31.4401 46.6779C30.6535 46.246 29.9886 45.6227 29.5069 44.8655C28.6307 45.0619 27.7191 45.034 26.8565 44.7842C25.994 44.5344 25.2085 44.0708 24.5729 43.4365C23.9373 42.8022 23.4721 42.0177 23.2205 41.1557C22.9689 40.2937 22.939 39.3821 23.1336 38.5055C22.3735 38.0245 21.7475 37.3591 21.3137 36.5711C20.8798 35.7832 20.6523 34.8983 20.6523 33.9988C20.6523 33.0994 20.8798 32.2145 21.3137 31.4265C21.7475 30.6386 22.3735 29.9732 23.1336 29.4922Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.b3c9660aaaa9ada883f6250e3d26aa2c.svg";
export { ForwardRef as ReactComponent };